export enum Preference {
  NotificationLivePro = 'MTR_NOTIFICATIONS_LIVEPRO'
}
